import React, { useContext, useState } from 'react';
import { adminUserPut } from '../../api';
import { useHistory } from "react-router-dom";
import { UserContext } from '../../context/User';
import Modal from '../UI/Modal';
import { somethingWentWrongNotice, successPasswordChangeNotice } from '../UI/Notifications';
import { useForm } from 'react-hook-form';
import ResetPasswordModalContent from '../ModalContents/ResetPasswordModalContent';
import { SearchContext } from '../../context/Search';

const ResetUserPassword = ({ id }) => {
  const { setIsLoggedIn, setUser } = useContext(UserContext);
  const history = useHistory();
  const { setLoading } = useContext(SearchContext);
  const [show, setShow] = useState(false);
  const { register, handleSubmit, errors } = useForm();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logout = () => {
    setIsLoggedIn(false);
    setUser({});
    history.push("/");
  }

  const handleDefaultStatusCodes = (status_code) => {
    if (status_code === 440 || status_code === 401) {
      logout();
    } else {
      somethingWentWrongNotice("Reset User Password");
    }

    setLoading(false);
  }

  const onSubmit = data => {
    setLoading(true);
    adminUserPut({password: data.password}, {user_id: id})
      .then(() => {
        handleClose();
        setLoading(false);
        successPasswordChangeNotice("Reset Password");
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        handleClose();
      });
  }

  const resetUserPassword = () => {
    handleShow();
  }

  return (
    <>
      <div
        onClick={() => resetUserPassword()}
        className="Dropdown_Item"
      >
        <span className="ml-2">Reset Password</span>
      </div>
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        buttonLabel="Reset Password"
      >
        <ResetPasswordModalContent 
          register={register}
          errors={errors}
        />
      </Modal>
    </>
  )
}

export default ResetUserPassword;
